package com.devi3east.bashbuddy.features.common.util

import androidx.compose.ui.text.AnnotatedString
import androidx.compose.ui.text.input.OffsetMapping
import androidx.compose.ui.text.input.TransformedText
import androidx.compose.ui.text.input.VisualTransformation

class PhoneNumberTransformation : VisualTransformation {
    override fun filter(text: AnnotatedString): TransformedText {
        val digits = text.text.filter { it.isDigit() }.take(10)

        val formatted = buildString {
            for (i in digits.indices) {
                when (i) {
                    0 -> append("(")
                    3 -> append(")-")
                    6 -> append("-")
                }
                append(digits[i])
            }
        }

        val offsetMapping = object : OffsetMapping {
            override fun originalToTransformed(offset: Int): Int {
                return when {
                    digits.isEmpty() -> 0
                    offset <= 0 -> 1
                    offset <= 3 -> offset + 1
                    offset <= 6 -> offset + 3
                    offset <= 10 -> offset + 4
                    else -> formatted.length
                }.coerceAtMost(formatted.length)
            }

            override fun transformedToOriginal(offset: Int): Int {
                return when {
                    offset <= 1 -> 0
                    offset <= 4 -> offset - 1
                    offset <= 8 -> offset - 3
                    offset <= 14 -> offset - 4
                    else -> digits.length
                }.coerceAtMost(digits.length)
            }
        }

        return TransformedText(AnnotatedString(formatted), offsetMapping)
    }
}